import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sms77 = defineConnector({
  identifier: "sms77",
  name: "seven",
  tagLine: "SMS gateway",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://gateway\\.seven\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [seven](https://www.seven.io/), go to **Developer → API Keys** to create an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://gateway.seven.io/api/hooks?action=read",
  },
});
